import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmDialog} from 'primeng/confirmdialog';

@Component({
  selector: 'confirmdialog-checkbox-footer',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirmdialog-checkbox-footer.component.html'
})
export class ConfirmDialogCheckboxFooterComponent {
  checkboxValue: boolean = false;

  @Input() confirmCheckboxText?: string

  @Input() confirmDialog!: ConfirmDialog;

  constructor() { }
}
